import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.feature-sets.po-custom-fields-view`

export default defineMessages({
  heading: {
    id: `${scope}.heading`,
    defaultMessage: 'Purchase order custom fields',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage:
      'Purchase order custom fields are not required. These custom fields will be displayed for all purchase orders.',
  },
  newCustomFieldButton: {
    id: `${scope}.newCustomFieldButton`,
    defaultMessage: 'New custom field',
  },
  createModalTitle: {
    id: `${scope}.createModalTitle`,
    defaultMessage: 'Create custom field',
  },
})
